import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={12} height={12} fill="none" {...props}>
    <Path
      fill="#FDFBF9"
      stroke="#FDFBF9"
      strokeWidth={0.5}
      d="M6 10.287a3.703 3.703 0 0 1-1.478-.296 3.823 3.823 0 0 1-1.206-.813 3.823 3.823 0 0 1-.813-1.206 3.703 3.703 0 0 1-.297-1.478h.319c0 .966.337 1.787 1.012 2.462C4.212 9.631 5.033 9.97 6 9.97c.967 0 1.787-.337 2.462-1.01.675-.673 1.013-1.494 1.013-2.465 0-.967-.338-1.787-1.013-2.46C7.787 3.361 6.967 3.025 6 3.025h-.231l.825.825-.232.219L5.156 2.85l1.231-1.219.232.225-.85.85H6c.525 0 1.018.1 1.478.297.46.198.863.469 1.206.813.344.343.615.745.813 1.206.198.46.297.95.297 1.472 0 .525-.1 1.017-.297 1.478-.198.46-.469.862-.813 1.206a3.823 3.823 0 0 1-1.206.813c-.46.197-.953.296-1.478.296Z"
    />
  </Svg>
);
export default SvgComponent;
